<div class="modal-header">
    <h4 class="modal-title">Accéder à un chantier</h4>
    <button (click)="onCloseSelectOtherChantierModale()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
    <div class="row">
        <form [formGroup]="selectOtherChantierForm">
            <div class="mb-3">
                <ng-select
                    (change)="onChantierChanged()"
                    (scrollToEnd)="onChantiersScrollToEnd()"
                    (search)="onChantiersSearchChanged($event.term)"
                    [clearable]="false"
                    [closeOnSelect]="true"
                    [loading]="chantiersSearchLoading"
                    [typeahead]="chantiersSearchKeyword$"
                    [virtualScroll]="true"
                    formControlName="chantierSearchField"
                    id="chantierSearchField"
                    notFoundText="Aucun chantier trouvé"
                    placeholder="Chantier"
                    typeToSearchText="Rechercher un chantier"
                >
                    @for (chantier of chantiersSearchedInModal$ | async; track chantier) {
                        <ng-option [value]="chantier.code">
              <span [title]="chantier.code + ' - ' + chantier.nom">{{
                      chantier.code + " - " + chantier.nom
                  }}</span>
                        </ng-option>
                    }
                </ng-select>
            </div>
        </form>
    </div>

    @if (chantierSearchInProgress) {
        <div class="row pt-2 h-100 align-items-center">
            <p class="card-text placeholder-wave">
                <span class="placeholder col-4"></span>&nbsp; <span class="placeholder col-6"></span>&nbsp;
                <span class="placeholder col-3"></span>&nbsp; <span class="placeholder col-5"></span>&nbsp;
                <span class="col-12 placeholder bg-white"></span>
                <span class="placeholder col-5"></span>&nbsp; <span class="placeholder col-3"></span>&nbsp;
                <span class="placeholder col-6"></span>&nbsp; <span class="placeholder col-4"></span>&nbsp;
            </p>
        </div>
    }
    @if (!chantierSearchInProgress && (chantierSelectedInModal$ | async)) {
        <div class="row ps-4 pb-3">
            <p class="px-0 m-0">
                La gestion des droits d'accès à ce chantier a évolué.
                <span class="d-block pt-2">Désormais, toutes les demandes de droits d'accès doivent être adressées directement à l'équipe Support.</span>
                <span class="d-block pt-2">
                Merci de contacter :
                <a class="fw-semibold text-black" [href]="'mailto:' + (supportEmail$ | async)" target="_blank">
                    {{ supportEmail$ | async }}
                </a>
            </span>
            </p>
        </div>
    }
</div>

<div class="modal-footer d-flex flex-column align-items-stretch">
    @if (!chantierSearchInProgress && (chantierIsParametre$ | async) === false && (chantierSelectedInModal$ | async)) {
        <button
            (click)="openLinkInNewTab('https://docs.google.com/forms/d/e/1FAIpQLScTibAl0gs8hvJXEk-uttaFsSVs9biroCrxN7fdEUOAEWc4Iw/viewform')"
            class="btn btn-outline-primary"
            type="button"
        >
            <span>Formulaire</span>
        </button>
    }
    @if (!chantierSearchInProgress && userIsSuperAdmin && (chantierSelectedInModal$ | async)) {
        <button (click)="onAccesAdminClick()" class="btn btn-primary" type="button">
            <span>Accès Super Admin</span>
        </button>
    }
    <button (click)="onCloseSelectOtherChantierModale()" class="btn btn-outline-secondary" type="button">Fermer</button>
</div>
